 import dashBoard from "@/api/dashBoard";
// import { formatISO,getLocalDate } from '@/utils/date-helpers';
// const fromDate=formatISO( new Date(new Date().setHours(0,0,0,0)));
// const toDate= formatISO(new Date(new Date().setHours(23,59,0,0)))
// const fromRosterDate= getLocalDate(new Date())
import { SIGNALR_PROPS, SIGNALR_STATUS } from "@/utils/constants";
import { VEHICLE_STATUS } from "@/utils/map/mapUtils";
import { initAnalytics } from "@/utils/util";
const state = {
    dashboardStatus:{},
    geoFence: { outOfGeofence: '0', withinGeofence: '0', },
    ignitionStatus: { on: '0', off: '0', },
    sosAlert: { count: '0', status: 'Ignition off', },
    temparature: {
        standard: '140',
        min: '50',
        max: '120',
    },
    gpsStatus: {
        active: '0', noGPS: '0', noCoverage: '0', switchedOff: '0',
    },
    speed: { high: '0', medium: '0', low: '0'},
    fleetStatus: {
        running: '01',
        idle: '02',
        stopped: '03',
        inactive: '04',
    },
    acStatus: 10,
    fuelUsage: [250, 500, 600, 300, 550, 270, 290],
    renewalStatus: { due: '01', overDue: '03', },
    immobilizerStatus: {
        stop: '10',
        stopping: '20',
        resuming: '15',
    },
    maintenance: { due: '05', overDue: '01' },
    fleetLoad: {
        [VEHICLE_STATUS.ACTIVE] : 0,
        [VEHICLE_STATUS.STOPPED] : 0,
        [VEHICLE_STATUS.INATCTIVE] : 0,
        [VEHICLE_STATUS.IDLE] : 0,
    },
    refreshTime:1,
    isProgress:true,
}
const getters = {
    getGeoFence: (state) => state.geoFence,
    getIgnitionStatus: (state) => state.ignitionStatus,
    getSosAlert: (state, getters, rootState, rootGetters) => rootGetters.getSosCount,
    getTemparature: (state) => state.temparature,
    getGpsStatus: (state) => state.gpsStatus,
    getSpeed: (state) => state.speed,
    getAcStatus: (state) => state.acStatus,
    getFuelUsage: (state) => state.fuelUsage,
    getRenewalStatus: (state) => state.renewalStatus,
    getImmobilizerStatus: (state, getters, rootState) => {
        //  state.immobilizerStatus;
        const vehicles = rootState.vehicles;
        let immobilizerStatus = {
            [VEHICLE_STATUS.ACTIVE] : 0,
            [VEHICLE_STATUS.STOPPED] : 0,
        };
        vehicles.forEach((ele) => {
            if (immobilizerStatus[ele.status] >= 0)
                immobilizerStatus[ele.status] ++;
        });
        return immobilizerStatus;
    },
    getMaintenance: (state) => state.maintenance,
    getFleetLoad: (state) => state.fleetLoad,
    // getVehicles: (state, getters, rootState) => {
    //     return rootState.vehicles;
    // },
    getFleetStatus: (state) => {
        let arrayObj = state.fleetStatus
        // for(let i = 0; i < state.fleetStatus.length; i++){
            arrayObj[VEHICLE_STATUS.ACTIVE] = arrayObj['running'];
            delete arrayObj.running;
            arrayObj[VEHICLE_STATUS.IDLE] = arrayObj['idle'];
            delete arrayObj.idle;
            arrayObj[VEHICLE_STATUS.INATCTIVE] = arrayObj['inActive'];
            delete arrayObj.inActive;
            arrayObj[VEHICLE_STATUS.STOPPED] = arrayObj['stopped'];
            delete arrayObj.stopped;
            arrayObj[VEHICLE_STATUS.NO_SIGNAL] = arrayObj['noSignal'];
            delete arrayObj.noSignal;
        // }
        // const vehicles = rootState.vehicles;
        // let fleetStatus = {
        //     [VEHICLE_STATUS.ACTIVE] : 0,
        //     [VEHICLE_STATUS.IDLE] : 0,
        //     [VEHICLE_STATUS.INATCTIVE] : 0,
        //     [VEHICLE_STATUS.STOPPED] : 0,
        //     [VEHICLE_STATUS.NO_SIGNAL] : 0,
        // };
        // vehicles.forEach((ele) => {
        //     if (fleetStatus[ele.status] >= 0)
        //         fleetStatus[ele.status] ++;
        // });
        console.log("getFleetStatus",state.fleetStatus)
        return state.fleetStatus;
    },
    getTotalVehiclesCount: (state, getters) => {
        const fleetStatus = getters.getFleetStatus;
        let total = 0;
        for (const key in fleetStatus) {
            total += fleetStatus[key];
        }
        return total;
    },//rootGetters.getVehicles.filter((v) => v.imei).length,
    getSignalrAnalytics: (state, getters, rootState, rootGetters) => {
        let analytics = initAnalytics();
        rootGetters.getVehicles.map((vh) => {
            if (vh.status != VEHICLE_STATUS.NO_SIGNAL) {
                analytics[SIGNALR_PROPS.SOS_PANIC] = vh[SIGNALR_PROPS.SOS_PANIC] == "0" ? analytics[SIGNALR_PROPS.SOS_PANIC] : analytics[SIGNALR_PROPS.SOS_PANIC] + 1;
                analytics[SIGNALR_PROPS.IGNITION] = vh[SIGNALR_PROPS.IGNITION] == "0" ? analytics[SIGNALR_PROPS.IGNITION] : analytics[SIGNALR_PROPS.IGNITION] + 1;
                analytics[SIGNALR_PROPS.POWER] = vh[SIGNALR_PROPS.POWER] == "0" ? analytics[SIGNALR_PROPS.POWER] : analytics[SIGNALR_PROPS.SOS_PANIC] + 1;
                analytics[SIGNALR_PROPS.AC] = vh[SIGNALR_PROPS.AC] == "0" ? analytics[SIGNALR_PROPS.AC] : analytics[SIGNALR_PROPS.AC] + 1;
                analytics[SIGNALR_PROPS.DOOR] = vh[SIGNALR_PROPS.DOOR] == "0" ? analytics[SIGNALR_PROPS.DOOR] : analytics[SIGNALR_PROPS.DOOR] + 1;

                [VEHICLE_STATUS.ACTIVE, VEHICLE_STATUS.IDLE].indexOf(vh.status) >= 0 ? analytics[SIGNALR_STATUS.IGNITION_ON] ++ : analytics[SIGNALR_STATUS.IGNITION_OFF] ++;
             }
        });
        return analytics;
    },
};

const actions = {
   async getDashboardStatus({commit}){
    const response = await dashBoard.getDashboardStatus()
    commit('getDashboardStatus', response.data.result)
   } 
}

const mutations = {
    getDashboardStatus(state,data){
        console.log("data",data)
        state.fleetStatus = data.vehicleLiveStatus
        state.gpsStatus = data.gpsStatus
        state.speed = data.speedStatus
        state.geoFence = data.geofenceStatus
        state.ignitionStatus = data.ignitionStatus
      state.dashboardStatus = data
    },
    getTime(state) {
        let val = JSON.parse(localStorage.getItem("refreshTimeVaue"));
        state.refreshTime = val ? val : state.refreshTime;
      },
    ChangeRefreshTime(state,e) {
        state.refreshTime = e.target.value;
      localStorage.setItem("refreshTimeVaue", e.target.value);
    },
    setIsProgress(state,value){
        state.isProgress=value;
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}